/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 01:53:27
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "@root/core/tags";

// uicSummary provide custom rule for "summary" for "audit".
@UITag.set()
export class uicNTD extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement, EUITagTarget.TableBodyCell];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input) ?? true;
        if (rule == false) return null;

        return {
            props: {
                prepend: "新台幣 $",
                append: "元",
            },
        };
    }
}
